module.exports = __webpack_public_path__ + "img/comparative-data.abc75687.png";